import { Box, Card, Grid, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { StatCardContent } from './StatCard';
import type { UserDashboardLifetimeRecordType } from '../../../types/userDashboardTypes';
import { userDashboardColors } from '../theme';

type PropsType = {
  records: UserDashboardLifetimeRecordType[];
};

const LifetimeRecordsSection = ({ records }: PropsType) => (
  <Box
    sx={{
      mt: 3,
      p: 3,
      borderRadius: 3,
      border: `1px solid ${userDashboardColors.neutral.border}`,
      bgcolor: userDashboardColors.neutral.sectionBg,
    }}
  >
    <Typography
      sx={{
        fontSize: 16,
        fontWeight: 600,
        color: userDashboardColors.neutral.heading,
        mb: 2.5,
      }}
    >
      Lifetime Records
    </Typography>
    <Grid container spacing={2}>
      {records.map((record) => (
        <Grid item xs={12} sm={4} key={record.id}>
          <Card
            sx={{
              p: 2.5,
              borderRadius: 3,
              border: `1px solid ${userDashboardColors.neutral.border}`,
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
              bgcolor: '#fff',
              height: '100%',
            }}
          >
            <StatCardContent
              icon={<PersonIcon />}
              label={record.label}
              value={record.value}
              variant={record.variant}
            />
            <Typography
              sx={{
                fontSize: 11,
                color: userDashboardColors.neutral.label,
                mt: 1.5,
                pl: 8,
              }}
            >
              Lifetime Total
            </Typography>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default LifetimeRecordsSection;
